'use es6';

import { createSelector } from 'reselect';
import { VALID_INTEGRATION_STATUSES } from 'ContentComponents/cmv2/constants';
export const getSalesforceIntegrationStatus = state => state.salesforceIntegrationStatus;
export const getIsSalesforceIntegrated = createSelector([getSalesforceIntegrationStatus], salesforceIntegrationStatus => {
  if (!salesforceIntegrationStatus) return null;
  return !!VALID_INTEGRATION_STATUSES[salesforceIntegrationStatus];
});